import { Component, input, InputSignal } from "@angular/core";
import { FieldTree, FormField } from "@angular/forms/signals";
import { ThousandizePipe } from "ev-core";
import { EvTooltipModule } from "ev-tooltip";

export interface MinMaxFilterConfig<T> {
    filterForm: InputSignal<FieldTree<T>>;
    title: string;
    fromFieldAccessor: (form: FieldTree<T>) => any;
    toFieldAccessor: (form: FieldTree<T>) => any;
    expandedAccessor: (form: FieldTree<T>) => any;
    fromFieldId: string;
    toFieldId: string;
    cssClass?: string;
    caption?: string;
    enableThousandize?: boolean; 
    tooltip?: {
        show: boolean;
        header: string;
        body: string;
    }
}

@Component({
    selector: "expandable-min-max-filter",
    imports: [FormField, EvTooltipModule, ThousandizePipe],
    templateUrl: "./expandable-min-max-filter.component.html",
    styleUrl: "./expandable-min-max-filter.component.scss",
})
export class ExpandableMinMaxFilterComponent<T> {
    config: InputSignal<MinMaxFilterConfig<T>> = input.required<MinMaxFilterConfig<T>>();

    protected get filterForm(): FieldTree<T> {
        return this.config().filterForm();
    }

    protected get title(): string {
        return this.config().title;
    }

    protected get fromField() {
        return this.config().fromFieldAccessor(this.filterForm);
    }

    protected get toField() {
        return this.config().toFieldAccessor(this.filterForm);
    }

    protected get expandedField() {
        return this.config().expandedAccessor(this.filterForm);
    }

    protected get fromFieldId(): string {
        return this.config().fromFieldId;
    }

    protected get toFieldId(): string {
        return this.config().toFieldId;
    }

    protected get tooltip() {
        return this.config().tooltip;
    }

    protected get cssClass(): string {
        return this.config().cssClass?.toString() || "";
    }

    protected get caption(): string {
        return this.config().caption?.toString() || "";
    }

    protected get enableThousandize(): boolean {
    return this.config().enableThousandize ?? false;
    }

    toggleExpanded(): void {        
        this.expandedField().value.set(!this.expandedField().value());
    }

    onBeforeInput(event: InputEvent): void {
        if (event.data !== ',') return;
        event.preventDefault();
        const input = event.target as HTMLInputElement;
        const start = input.selectionStart ?? input.value.length;
        const end = input.selectionEnd ?? input.value.length;
        input.value = input.value.substring(0, start) + '.' + input.value.substring(end);
        input.setSelectionRange(start + 1, start + 1);
        input.dispatchEvent(new Event('input', { bubbles: true }));
    }

    onAfterInput(event: Event): void {
        const input = event.target as HTMLInputElement;
        let value = input.value.replace(/[^0-9.,]/g, '');
        value = value.replace(',', '.').replace(/(?!^)-/g, '').replace(/(?!^)\./g, '');
        input.value = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
    }
}
